import React, { useState, useEffect } from 'react';
import { template as tmpl } from './BookingList.tmpl';
import { connect } from 'react-redux';

const BookingListLogic = (props) => {
    const { activeCompany } = props;

    const initBookings = async () => {
        //
    };

    /**
     * Get Booking list
     */
    useEffect(() => {
        initBookings();
    }, [activeCompany]);

    const navigate = (route, id, state) => {
        props.history.push({
            pathname: route,
            search: id,
            state: state
        });
    };

    const initProps = {
        navigate: navigate
    };

    return tmpl && tmpl({ ...initProps });
};

class BookingListContainer extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const initProps = {
            ...this.props
        };
        return <BookingListLogic {...initProps} />;
    }
}

const mapStateToProps = (state) => {
    const { companyReducer } = state;
    const { customers, activeCompany } = companyReducer;
    return {
        customers: customers,
        activeCompany: activeCompany // TODO : fetch booking list on change company
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        //
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BookingListContainer);
